import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesStruct = () => {

return(
<div>
<br /><br />
<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
 <br /><br />
 Willer, C. J. et al. Six new loci associated with body mass index highlight a neuronal influence on body weight regulation. Nat. Genet. 41, 25–34 (2009)<br />
Speliotes, E. K. et al. Association analyses of 249,796 individuals reveal 18 new loci associated with body mass index. Nat. Genet. 42, 937–948 (2010)<br />
Jarick, I. et al. Novel common copy number variation for early onset extreme obesity on chromosome 11q11 identified by a genome-wide analysis. Hum. Mol. Genet. 20, 840–852 (2011)<br />
Falchi, M. et al. Low copy number of the salivary amylase gene predisposes to obesity. Nat. Genet. 46, 492–497 (2014)<br />
https://www.nature.com/articles/s41576-021-00414-z<br />    
https://pubmed.ncbi.nlm.nih.gov/29484031/<br /> 
https://pubmed.ncbi.nlm.nih.gov/22891219/<br /> 
</div>
)
}